/* globals PropTypes */

import moment from 'moment'
import cn from 'classnames'
import { parseFlexibleDate } from 'lib/parseFlexibleDate'

const MOMENT_FORMAT = 'DD.MM.YYYY'
const FLATPICKR_FORMAT = 'd.m.Y'

function formatDate (date) {
  return date ? moment(date).format(MOMENT_FORMAT) : ''
}

// The initial and the submitted value go through the same parser as flatpickr, so they can't disagree;
// an unparseable value (e.g. one typed into the field earlier) becomes '' instead of "Invalid date"
function normalizeDate (value) {
  return formatDate(parseFlexibleDate(value))
}

export default class DateInput extends React.Component {
  constructor (props) {
    super()
    this.state = {
      value: normalizeDate(props.value),
      focused: false
    }
    this.datepicker = React.createRef()
  }

  componentDidMount () {
    $(this.datepicker.current).flatpickr({
      dateFormat: FLATPICKR_FORMAT,
      allowInput: true,
      parseDate: parseFlexibleDate,
      onChange: ([date]) => this.setState({ value: formatDate(date) })
    })
  }

  render () {
    const classes = cn({
      'show-labelholder': this.state.value,
      focused: this.state.focused
    }, 'labelholder')
    // The typed text is only submitted once it parses as a date: flatpickr normalizes it on blur,
    // but text can reach the form without a blur (Enter, browser autofill) and went to the server as is.
    return (
      <div
        className={classes}
        data-label={this.props.placeholder || ''}
      >
        <input
          type='text'
          className='form-control'
          value={this.state.value}
          onChange={(e) => this.setState({ value: e.target.value })}
          onFocus={() => this.setState({ focused: true })}
          onBlur={() => this.setState({ focused: false })}
          placeholder={this.props.placeholder || ''}
          ref={this.datepicker}
          id={this.props.field}
        />
        <input type='hidden' name={this.props.name} value={normalizeDate(this.state.value)} />
        <div className='remover' onClick={this._clear.bind(this)} />
      </div>
    )
  }

  _clear () {
    this.setState({ value: '' })
  }
}

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string
}
